import { render, staticRenderFns } from "./generic-alert.vue?vue&type=template&id=48d63877&scoped=true&"
import script from "./generic-alert.vue?vue&type=script&lang=js&"
export * from "./generic-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d63877",
  null
  
)

export default component.exports